import { List } from "antd";
import AnnounceIconSVG from "../../Icons/announceIconSVG";
import dayjs from "dayjs";

const AnnouncementBar = ({ announcements }) => {
  return (
    <div>
      <List
        loading={false}
        itemLayout="horizontal"
        dataSource={announcements}
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta
              avatar={<AnnounceIconSVG />}
              title={
                <p className="text-base text-blue font-medium ml-4">
                  {item.AnnouncementText}
                </p>
              }
              description={
                <div className="flex items-center">
                  <p className="text-sm text-gray-500 ml-4">
                    {item.AnnouncementEndDate
                      ? `Ends: ${dayjs(item.AnnouncementEndDate).format("YYYY-MM-DD")}`
                      : "No end date"}
                  </p>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default AnnouncementBar;